import {
  Component,
  Input,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { ConsoleService } from 'src/app/core/services/console.service';
import {
  CreateGroupPriceDetailCommand,
  GetEnumValuesDto,
  GroupPriceByOrganizationIdDto,
  GroupPriceDetailDto,
  UpdateGroupPriceDetailCommand,
} from '../../../../core/api/models';
import { SmsAggregator } from '../../../../core/api/models/sms-aggregator';
import { SmsCp } from '../../../../core/api/models/sms-cp';
import { SmsLanguage } from '../../../../core/api/models/sms-language';
import { GroupPriceDetailsService } from '../../../../core/api/services/group-price-details.service';
import { EventTypes } from '../../../../core/constants/event-types';
import { KeyValueModel } from '../../../../core/models/key-value.model';
import { UtilityService } from '../../../../core/services/utility.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import {
  DialogService,
  DialogStatus,
} from './../../../../core/services/dialog.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { SmsAggregatorBgColor } from '../shared/directives/sms-aggregator-background-color.directive';
import { SmsAggregatorImage } from '../shared/directives/sms-aggregator-image.directive';
import { SmsAggregatorImageWidth } from '../shared/directives/sms-aggregator-image-width.directive';

//compress text method
declare function compressToEncodedURIComponent(input): any;
declare function decompressFromEncodedURIComponent(input): any;

@Component({
    selector: 'app-group-price-details-form',
    templateUrl: './group-price-details-form.component.html',
    styleUrls: ['./group-price-details-form.component.scss'],
    imports: [BaseFormModule, SmsAggregatorBgColor, SmsAggregatorImage, SmsAggregatorImageWidth]
})

export class GroupPriceDetailsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  pageVocabs = 'pages.groupPrice.detailForm.';

  @Input() formPageConfig: FormPageConfig<GroupPriceDetailDto[]>;
  @Input() groupPrices: GroupPriceByOrganizationIdDto = {};
  @Input() groupPriceDetail: GroupPriceDetailDto[] = [];
  @Input() readOnly: boolean = false;
  @Input() showPageHeader: boolean = true;
  @Input() tagName: string;

  model: CreateGroupPriceDetailCommand = {};
  editModel: UpdateGroupPriceDetailCommand = {};

  //#region enums
  SmsCpEnumValues: GetEnumValuesDto[] = [];
  SmsCpValues = this.utilityService.enumValuesToArray(SmsCp);
  SmsLanguageValues = this.utilityService.enumValuesToArray(SmsLanguage);
  SmsAggregatorValues: KeyValueModel[] =
    this.utilityService.enumToObject(SmsAggregator);
  //#endregion

  //#endregion

  constructor(
    protected currentService: GroupPriceDetailsService,
    protected utilityService: UtilityService,
    protected dialogService: DialogService,
    protected renderer: Renderer2
  ) {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.loading = false;
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
    this.title = this.pageVocabs + 'legend';
  }

  ngAfterViewInit(): void {
    this.initModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.groupPrices && Object.keys(this.groupPrices)?.length != 0) {
      if (Object.keys(this.groupPrices.details)?.length)
        this.setGroupPriceDetail(this.groupPrices.details);
    }
    //for myGroupPriceDetail and organizationGroupPriceDetail
    else if (Object.keys(this.groupPriceDetail)?.length)
      this.setGroupPriceDetail(this.groupPriceDetail);
  }

  //#region init methods

  initModel() {
    //for edit group price detail
    if (
      this.formPageConfig.isEditMode &&
      this.formPageConfig.editData.length > 0
    )
      this.setGroupPriceDetail(this.formPageConfig.editData);
  }

  initForm() {
    this.form = new FormGroup({
      groupPriceId: new FormControl(''),
    });
  }

  //#endregion

  //#region groupPriceDetail model

  getGroupPriceDetail(): GroupPriceDetailDto[] {
    try {
      const inputs: Element[] = this.getInputs();

      let model = inputs.map((item: Element) => {
        return {
          price: +(<HTMLInputElement>item).value,
          smsCp: +(<HTMLInputElement>item).dataset.smscp,
          smsAggregator: +(<HTMLInputElement>item).dataset.aggregator,
          smsLanguage: +(<HTMLInputElement>item).dataset.lang,
        };
      });

      return model;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  setGroupPriceDetail(model: GroupPriceDetailDto[]) {
    try {
      const TimeOut = setTimeout(() => {
        model.forEach((item) => {
          let id =
            `${this.tagName} #item${item.smsAggregator}-${item.smsCp}-${item.smsLanguage}`.toString();
          let input = <HTMLInputElement>document.querySelector(id);
          if (input)
            this.renderer.setProperty(input, 'value', item?.price?.toString());

          // input.value = item?.price?.toString();
        });
        clearTimeout(TimeOut);
      }, 200);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
  //#endregion

  //#region table inputs

  getInputs(): Element[] {
    try {
      const inputElements: NodeListOf<Element> = document.querySelectorAll(
        `${this.tagName} .input-item`
      );
      return Array.from(inputElements);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  isEmptyInputs(): boolean {
    try {
      const inputs: Element[] = this.getInputs();
      let isValid: boolean = true;

      inputs.forEach((item: Element) => {
        let price = +(<HTMLInputElement>item).value;
        if (!price) {
          (<HTMLInputElement>item).style.cssText = `
          background-color:#fae7e7;

          `;
          isValid = false;
        }
      });
      return isValid;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  isEmptyInput(event) {
    try {
      if (!event.target.value) {
        (<HTMLInputElement>event.target).style.cssText = `
        background-color:#fae7e7;
        `;
      } else {
        (<HTMLInputElement>event.target).removeAttribute('style');
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  resetInputs() {
    try {
      const inputs: Element[] = this.getInputs();
      inputs.forEach((item: Element) => {
        this.renderer.setProperty((<HTMLInputElement>item).value, 'value', '');

        // (<HTMLInputElement>item).value = '';
        let price = +(<HTMLInputElement>item).value;
        if (!price) (<HTMLInputElement>item).removeAttribute('style');
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  fillColumn(smsAggregator, lang, event?) {
    try {
      if (event) if (event?.key !== 'Enter' && event?.type != 'change') return;

      //get input value
      let id = `${this.tagName} #input-${smsAggregator}-${lang}`.toString();
      let value = +(<HTMLInputElement>document.querySelector(id)).value;

      //get input elements and set value
      let inputs = this.getInputs();
      inputs.forEach((item) => {
        if (
          item.getAttribute('data-aggregator') == smsAggregator &&
          item.getAttribute('data-lang') == lang
        ) {
          this.renderer.setProperty(
            <HTMLInputElement>item,
            'value',
            value.toString()
          );

          // (<HTMLInputElement>item).value = value.toString();
          (<HTMLInputElement>item).removeAttribute('style');
        }
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateGroupPriceDetailCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .groupPriceDetailsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateGroupPriceDetailCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .groupPriceDetailsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region table copyPaste

  copyTableContent() {
    try {
      const jsonText = JSON.stringify(this.getGroupPriceDetail());
      const compressed = compressToEncodedURIComponent(jsonText);
      navigator.clipboard.writeText(compressed);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  pasteTableContent() {
    navigator.clipboard
      .readText()
      .then((text) => {
        try {
          const deCompressed = decompressFromEncodedURIComponent(text);
          const model = JSON.parse(deCompressed) as GroupPriceDetailDto[];
          this.setGroupPriceDetail(model);
        } catch (error) {
          this.dialogService.openDialog({
            title: 'common.error',
            message: 'messages.contentIsInvalid',
            status: DialogStatus.error,
          });
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.systemManagement
          );
        }
      })
      .catch((error) => {
        ConsoleService.error('Failed to read clipboard contents: ', error);
      });
  }

  //#endregion

  //#region operation

  onReset() {
    this.loading = true;
    super.onReset();
    this.resetInputs();
    this.loading = false;
  }

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    try {
      //check is empty table
      if (!this.isEmptyInputs()) return;

      //get table content
      this.groupPriceDetail = this.getGroupPriceDetail();

      //update
      if (this.formPageConfig.isEditMode) {
        this.editModel.updateGroupPriceDetailInput = this.groupPriceDetail;
        this.editModel.groupPriceId = this.formPageConfig.editId;
        this.formPageConfig.editData.forEach((item, index) => {
          if (this.editModel.updateGroupPriceDetailInput[index] != null)
            this.editModel.updateGroupPriceDetailInput[
              index
            ].groupPriceDetailId = item.id;
        });
        this.baseUpdateApi(this.editModel);
        return;
      }

      //create
      this.model.createGroupPriceDetails = this.groupPriceDetail;
      this.model.groupPriceId = this.formPageConfig.editId;
      this.baseCreateApi(this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#endregion
}
